import { useTranslation } from 'react-i18next';
import { useIsObserver } from '@platform/features/auth';
import { useViewsQuery } from '@platform/state/api';
import { Icon } from '@platform/ui';
import type { SavedViewKind } from '@platform/core/types';
import type { ISavedViewPickerProps } from './ISavedViewPickerProps';
import { savedViewSummary } from './savedViewSummary';

const KIND_ICON: Record<SavedViewKind, string> = { any: 'layers', table: 'panels-top-left', board: 'square-kanban', cards: 'layout-grid', calendar: 'calendar' };

/**
 * Збережене подання (UIUX tables/saved-views, прототип v4): акцентна плитка з іконкою виду, вибір «Типове подання» + «Назва · Вид»,
 * кнопки «Редагувати подання» (повзунки) і «Нове подання» (+; у сесії спостерігача — немає, подання не зберігаються), поруч із вибраним —
 * підсумок «Вид · N фільтрів» (12px, приглушений).
 */
export function SavedViewPicker({ ws, rt, value, onChange, onEdit, onNew }: ISavedViewPickerProps) {
  const { t } = useTranslation();
  const { data: views = [] } = useViewsQuery({ ws, recordType: rt });
  const current = views.find((v) => v.id === value);
  const summary = current ? savedViewSummary(current, t) : '';
  const observer = useIsObserver();
  return (
    <>
      <label className="lv-saved" title={t('listbar.savedView')}>
        <span className="lv-saved__ico" aria-hidden="true"><Icon name={KIND_ICON[current?.kind ?? 'table']} size={14} /></span>
        <select className="lv-select" value={current ? current.id : ''} aria-label={t('listbar.savedView')} onChange={(e) => onChange(views.find((v) => v.id === e.target.value) ?? null)}>
          <option value="">{t('listbar.defaultView')}</option>
          {views.map((v) => <option key={v.id} value={v.id}>{`${v.name}  ·  ${t(`listbar.viewKinds.${v.kind}`)}`}</option>)}
        </select>
      </label>
      {!observer && <button type="button" className="lv-sqbtn" aria-label={t('listbar.editView')} title={t('listbar.editViewHint')} onClick={onEdit}><Icon name="sliders-horizontal" size={15} /></button>}
      {!observer && <button type="button" className="lv-sqbtn" aria-label={t('listbar.newView')} title={t('listbar.newView')} onClick={onNew}><Icon name="plus" size={15} strokeWidth={2} /></button>}
      {summary && <span className="lv-saved__info" title={summary}>{summary}</span>}
    </>
  );
}
